import { useCurrentUser } from "@/hooks/useCurrentUser";

const WRITE_ROLES = ["App.ADMIN", "App.SCHEMA_CREATOR"] as const;
const PUBLISH_ROLES = ["App.ADMIN"] as const;
const ARCHIVE_ROLES = ["App.ADMIN"] as const;
const DELETE_ROLES = ["App.ADMIN", "App.SCHEMA_CREATOR"] as const;

export interface SchemaPermissions {
  /** schema.write — create schemas, edit draft columns / rules */
  canWrite: boolean;
  /** schema.publish — promote a draft to published */
  canPublish: boolean;
  /** schema.archive — soft-delete a schema */
  canArchive: boolean;
  /** schema.delete — permanently delete a draft */
  canDelete: boolean;
}

export function useSchemaPermissions(): SchemaPermissions {
  const currentUser = useCurrentUser();

  if (!currentUser) {
    return { canWrite: false, canPublish: false, canArchive: false, canDelete: false };
  }

  const { roles } = currentUser;
  return {
    canWrite: WRITE_ROLES.some((r) => roles.includes(r)),
    canPublish: PUBLISH_ROLES.some((r) => roles.includes(r)),
    canArchive: ARCHIVE_ROLES.some((r) => roles.includes(r)),
    canDelete: DELETE_ROLES.some((r) => roles.includes(r)),
  };
}
